export default __webpack_public_path__ + "static/media/ust.61b91beb.svg";